// Maps importedName -> { width, height } for in-flight uploads.
// For canvas imports: importedName is the UUID S3 key stem (unique).
// For desktop uploads: importedName is the filename stem (not unique across concurrent same-named files).
// Desktop upload consumers should prefer clipId-keyed lookups (see useGalleryAssets) over this cache.
const dimensionsByImportedName = new Map<string, { width: number; height: number }>();

export const registerUploadDimensions = (importedName: string, dimensions: { width: number; height: number }) => {
  dimensionsByImportedName.set(importedName, dimensions);
};

export const getUploadDimensions = (
  importedName: string | undefined,
): { width: number; height: number } | undefined => {
  if (!importedName) {
    return undefined;
  }

  return dimensionsByImportedName.get(importedName);
};

export const releaseUploadDimensions = (importedName: string) => {
  dimensionsByImportedName.delete(importedName);
};
